export const holidayTypes = {
    FLIGHT_HOTEL: 'FlightHotel',
    FLIGHT_CAR: 'FlightCar'
}
